













import { defineComponent, PropType, computed } from '@vue/composition-api'
import { TShirtSize, atLeast } from '@/lib/sizing'
import { sizeToFontSize } from '@/lib/tailwind'
import { sizeToFaIconSize } from '@/lib/font-awesome'
import { Orientation } from '@/lib/positioning'

export const statuses = ['info', 'warning', 'success', 'failure'] as const
export type Status = typeof statuses[number]

const statusColors: Record<Status, string> = {
  info: 'text-blue-500',
  warning: 'text-yellow-500',
  success: 'text-green-500',
  failure: 'text-red-600'
}
export const statusToColor = (status: Status): string => statusColors[status]

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCheckCircle,
  faTimesCircle
} from '@fortawesome/free-regular-svg-icons'
import {
  faInfoCircle,
  faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons'
library.add(faCheckCircle, faTimesCircle, faInfoCircle, faExclamationTriangle)

const statusIcons: Record<Status, Array<string>> = {
  info: ['fas', 'info-circle'],
  warning: ['fas', 'exclamation-triangle'],
  success: ['far', 'check-circle'],
  failure: ['far', 'times-circle']
}
export const statusToIcon = (status: Status): Array<string> =>
  statusIcons[status]

export default defineComponent({
  props: {
    status: String as PropType<Status>,
    icon: String,
    color: {
      type: String,
      default: 'black'
    },
    message: String,
    detail: String,
    size: {
      type: String as PropType<TShirtSize>,
      default: 'medium'
    },
    layout: {
      type: String as PropType<Orientation>,
      default: 'vertical'
    },
    detailColor: {
      type: String,
      default: 'text-gray-700'
    }
  },
  setup(props) {
    const statusIcon = computed(() =>
      props.status ? statusToIcon(props.status) : props.icon
    )
    const fontSize = computed(() => sizeToFontSize(props.size))
    const iconSize = computed(() => sizeToFaIconSize(props.size))
    const statusColor = computed(() =>
      props.status ? statusToColor(props.status) : props.color
    )

    const classes = computed(() => ({
      [fontSize.value]: true,
      [statusColor.value]: true,
      'flex-row': props.layout == 'horizontal',
      'flex-col': props.layout == 'vertical'
    }))

    const title = computed(
      () => `${props.message ?? ''}\n` + `${props.detail ?? ''}`
    )

    const detailClasses = computed(() => ({
      [props.detailColor]: true
    }))

    const atLeastSmall = atLeast('small')
    const isAtLeastSmall = computed(() => atLeastSmall(props.size))
    return {
      statusIcon,
      fontSize,
      iconSize,
      classes,
      detailClasses,
      title,
      statusColor,
      isAtLeastSmall
    }
  }
})
